var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopifyLogo = function SvgShopifyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ShopifyLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#81BF37",
    fillRule: "evenodd",
    d: "M16.512 4.586v-.312c0-.956-.132-1.727-.344-2.337.852.107 1.42 1.08 1.784 2.201zm-1.88 9.535s-.997-.535-2.218-.535c-1.791 0-1.882 1.13-1.882 1.414 0 1.553 4.028 2.149 4.028 5.786 0 2.861-1.806 4.705-4.241 4.705-2.923 0-4.417-1.828-4.417-1.828l.782-2.598S8.22 22.39 9.517 22.39c.846 0 1.192-.67 1.192-1.16 0-2.025-3.306-2.116-3.306-5.445 0-2.802 2.002-5.513 6.04-5.513 1.557 0 2.327.448 2.327.448zm-.664-13.083a.87.87 0 0 1 .494.168c-1.234.583-2.556 2.053-3.114 4.987l-2.352.732c.653-2.238 2.207-5.887 4.972-5.887m1.535 3.694V4.9l-2.977.927c.573-2.222 1.647-3.296 2.587-3.7.236.596.39 1.451.39 2.606m4.433-1.194c-.061.008-.114.02-.151.031l-.892.277C18.361 2.306 17.421.892 15.77.892q-.07 0-.14.004C15.16.272 14.577 0 14.074 0c-3.85 0-5.69 4.838-6.266 7.295l-2.694.84c-.836.263-.862.29-.971 1.08-.083.599-2.268 17.58-2.268 17.58L18.9 30l.018-.004zm1.218.834 1.05 1.046s2.293.17 2.401.18c.11.01.241.093.261.244.021.15 3.259 22.153 3.259 22.153l-7.945 1.727z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ShopifyLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgShopifyLogo;